import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouterProvider } from 'react-router-dom'

import { setLanguageList } from '@/app/slices/appSlice'
import { resolveLocizeBackend } from '@/common/utils/locizeCacheConfig'
import i18n from '@/i18n'

import SplitProviderWrapper from './layout/SplitProviderWrapper'
import { router } from './router'

import './App.css'

const App = () => {
    const dispatch = useDispatch()

    // Fetch available languages once on mount.
    // The Locize backend may be wrapped by i18next-chained-backend when
    // translation caching is enabled (QM-3418), so resolve the instance that
    // actually exposes getLanguages rather than assuming it is the top backend.
    useEffect(() => {
        const locizeBackend = resolveLocizeBackend(i18n.services.backendConnector.backend)
        locizeBackend?.getLanguages((err, result) => {
            if (!err) {
                dispatch(setLanguageList(result))
            }
        })
    }, [dispatch])

    return (
        <SplitProviderWrapper>
            <RouterProvider router={router} />
        </SplitProviderWrapper>
    )
}

export default App
